<template>

  <SubHeading :home="home" :tabs="tabs" :shorts="false" :currTab="currTab" @active="handleActive" />

    <!-- breadcrumbs -->
    <nav class="sba-collection-breadcrumb z-depth-0">
      <div class="container nav-wrapper">
        <div class="sba-collection-breadcrumb-row">
          <router-link to="/" class="breadcrumb sba-collection-crumb teal-text">
            <i class="material-icons">home</i>
            <span>Dashboard</span>
          </router-link>
          <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
          <span class="breadcrumb sba-collection-crumb blue-grey-text pointable">
            <span>Provider Enrollees</span>
          </span>
          <span class="sba-collection-context">Provider Enrollee Register</span>
        </div>
      </div>
    </nav>

  <!-- Top -->
  <div id="top"></div>

  <div class="container care-page-shell">
    <div class="care-workbench sba-slide-in">
      <div class="care-review-head">
        <div class="care-title-row">
          <div class="care-title-block">
            <label class="active teal-text">Provider List</label>
            <h5>Accessible Enrollees</h5>
            <p>Search active members by client, enrollee identity, and coverage period.</p>
          </div>
          <button type="button" class="care-search-toggle" @click="toggleSearchFilters">
            <span>{{ showSearchFilters ? "Hide Search" : "Show Search" }}</span>
            <i class="material-icons">{{ showSearchFilters ? "expand_less" : "tune" }}</i>
          </button>
        </div>
      </div>

      <div class="care-filter-shell" v-show="showSearchFilters">
        <div class="care-filter-card">
          <FilterList @search="handleSearch" />
        </div>
      </div>

        <LoadingDiv v-if="!isReady" />

        <div v-else>
          <div class="care-search-summary">
            <span class="summary-label">Current view</span>
            <div class="summary-content" v-if="searchTitle" v-html="searchTitle"></div>
            <div class="summary-content" v-else>
              <span class="summary-chip">All provider enrollees</span>
            </div>
          </div>

          <div class="progress care-progress" v-if="isLoading">
            <div class="indeterminate"></div>
          </div>

          <div class="care-list-card" v-if="enrollees.length">
              <div class="care-table-head hide-on-med-and-down">
                <span>No.</span>
                <span>Member</span>
                <span>Enrollee ID</span>
                <span>Client</span>
                <span>Period</span>
              </div>

              <div class="care-row-card" v-for="(enrollee, index) in enrollees" :key="enrollee.id">
                <div class="care-row-grid">
                  <div class="hide-on-small-only">
                    <span class="care-number">{{ numberBadge(index) }}</span>
                  </div>
                  <div class="care-person">
                    <h6>
                      <span>{{ enrollee.name.toUpperCase() }}</span>
                      <span class="care-type-text" :class="enrolleeTypeMeta(enrollee.type).className">
                        {{ enrolleeTypeMeta(enrollee.type).label }}
                      </span>
                    </h6>
                    <div class="care-contact-line">
                      <span v-if="ageSex(enrollee.dob, enrollee.sex)">
                        {{ ageSex(enrollee.dob, enrollee.sex)?.toUpperCase() }}
                      </span>
                      <span class="contact-dot" v-if="ageSex(enrollee.dob, enrollee.sex) && enrollee.phone"></span>
                      <span>{{ enrollee.phone || "No phone recorded" }}</span>
                    </div>
                    <div class="care-id-line">
                      <span>Scheme</span>
                      <strong>{{ enrollee?.scheme?.name || "No scheme recorded" }}</strong>
                    </div>
                  </div>
                  <div class="care-data-cell">
                    <span>Enrollee ID</span>
                    <p class="care-cell-value">{{ enrollee.enrollee_number || "No ID recorded" }}</p>
                  </div>
                  <div class="care-data-cell">
                    <span>Client</span>
                    <p class="care-cell-value">{{ enrollee.client_name || "No client recorded" }}</p>
                  </div>
                  <div class="care-data-cell hide-on-small-only">
                    <span>Period</span>
                    <p class="care-period">
                      {{
                        new Date(listMonth).toLocaleString(undefined, {
                          year: "numeric",
                          month: "short",
                        })
                      }}
                    </p>
                  </div>
                </div>
              </div>
          </div>


          <div class="care-empty-state" v-if="!isLoading && !enrollees.length">
            <h6><img src="@/assets/img/no-user.png" width="192" class="circle responsive-img" /></h6>
            <p>No provider enrollee record matched the current selection.</p>
          </div>

          <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
        </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import getItems from "@/composables/getItems";
import SubHeading from "@/components/HeaderSubDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";
import FilterList from "@/components/list/FilterListComponent.vue";
import { getCache, addCache } from "@/composables/cache/cache";


export default {
  name: "listHome",
  components: { SubHeading, LoadingDiv, PaginationDiv, FilterList },
  setup() {
    const response = ref(null);
    const listMonth = ref(null);
    const searchTitle = ref(null);
    const isReady = ref(false);
    const isLoading = ref(true);
    const error = ref(null);
    const currUrl = ref(null);
    const currHook = ref(null);
    const home = ref(null);
    const currTab = ref(null);
    const tabs = ref([]);
    const showSearchFilters = ref(false);

    // vue router
    const router = useRouter();

    // start
    onMounted(() => {
      // page name
      document.title = "Active (Monthly) Enrollees";
    });

    // menu
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Enrollees List", title: "Home", icon: null, url: "list", hash: null, });

      // set default
      currTab.value = tabs.value.find(x => x.title.includes("Home"));
      // set home
      home.value = tabs.value.find(x => x.title.includes("Home"));
    });

    // handle curr status
    const handleActive = (tab) => {
      // refer
      if (tab.hash) {
        router.push({ name: tab.url, hash: tab.hash });
      } else {
        router.push({ name: tab.url });
      }
    };

    // get function
    const getItemsFromApi = (table) => {

      // get item from store (cache)
      let cache = getCache(table);

      if (cache?.length) {
        response.value = cache;
      }

      (async () => {
        const { res, err } = await getItems(table);

        if (res.value) {
          response.value = res.value.data;
          // add cache
          addCache(table, response.value);
        } else {
          error.value = err.value;
        }

        // page is ready, loading is complete
        isReady.value = true;
        isLoading.value = false;
      })();
    };

    // numbering
    const numberBadge = (num) => {
      return (
        (allPages.value.current_page - 1) * allPages.value.per_page + num + 1
      );
    };

    const enrolleeTypeMeta = (type) => {
      if (type === "p") {
        return { label: "Principal", className: "is-principal" };
      }

      if (type === "s") {
        return { label: "Spouse", className: "is-spouse" };
      }

      if (type === "d") {
        return { label: "Dependant", className: "is-dependant" };
      }

      return { label: "Unclassified", className: "is-unclassified" };
    };

    const toggleSearchFilters = () => {
      showSearchFilters.value = !showSearchFilters.value;
    };

    // current month, year
    const getCurrentMonthYear = () => {
      return `${new Date().toLocaleDateString("en", {
        month: "long",
      })} ${new Date().getFullYear()}`;
    };

    // display function
    const ageSex = (dob, sex) => {
      let ageSex;
      let birthDateObj = new Date(dob);
      let today = new Date();
      let age = today.getFullYear() - birthDateObj.getFullYear();

      if (
        today.getMonth() < birthDateObj.getMonth() ||
        (today.getMonth() === birthDateObj.getMonth() &&
          today.getDate() < birthDateObj.getDate())
      ) {
        age--;
      }

      if (dob && sex) {
        ageSex = `(${sex}/${age})`;
      } else if (dob) {
        ageSex = `(${age}yrs)`;
      } else if (sex) {
        ageSex = `(${sex})`;
      }

      return ageSex;
    };

    // handle search (emitted from component)
    const handleSearch = (val) => {
      // start loading
      isLoading.value = true;
      // set current Url
      currUrl.value = val.currUrl;
      // set current Hook
      currHook.value = val.currHook;
      // set listMonth
      listMonth.value = val.listMonth;
      // set search title
      searchTitle.value = val.searchTitle;
      // get items from function
      getItemsFromApi(currUrl.value);
    };

    // switch page
    const handlePage = (page) => {
      // start laoding
      isLoading.value = true;
      // go back up
      router.push({ hash: "#top" });
      // get new page items from function
      getItemsFromApi(`${currUrl.value}${currHook.value}page=${page}`);
    };

    // output results
    const enrollees = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value.data;
      }
    });

    // output pages
    const allPages = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value; // get all
      }
    });

    return {
      handleActive,
      home,
      currTab,
      tabs,
      ageSex,
      numberBadge,
      enrolleeTypeMeta,
      toggleSearchFilters,
      getCurrentMonthYear,
      handleSearch,
      handlePage,
      isReady,
      isLoading,
      error,
      listMonth,
      searchTitle,
      showSearchFilters,
      enrollees,
      allPages,
    };
  },
};
</script>

<style scoped>
.line {
  margin-top: -45px;
}

.progress {
  margin: 0;
  border-radius: 0;
}

.pointer {
  cursor: default;
}

/* base class */
.tab-custom {
  display: inline-block;
  cursor: pointer;
  margin: 0 0 -1px;
  padding: 15px 25px;
  font-weight: 600;
  text-align: center;
  color: #bbb;
  border: 1px solid transparent;
}

.tab-custom:hover {
  color: #000000 !important;
}

/* Removed
color: #000000;
border: 1px solid #ddd;
background-color: #d1f3df; */
.tab-custom-active {
  display: inline-block;
  cursor: pointer;
  margin: 0 0 -1px;
  padding: 15px 25px;
  font-weight: 600;
  text-align: center;
  border-bottom: 2px solid orange;
}

/* display */
.tab-custom-section {
  padding: 20px 0 0;
  border-top: 1px solid #ddd;
}

.care-page-shell {
  margin-top: -14px;
  padding-top: 0;
  padding-bottom: 12px;
  position: relative;
  z-index: 1;
}

:global(html:has(.care-page-shell)),
:global(body:has(.care-page-shell)),
:global(.app-shell:has(.care-page-shell)),
:global(.app-shell:has(.care-page-shell) main) {
  background: var(--care-gutter-bg) !important;
  background-color: var(--care-gutter-bg) !important;
}

.care-workbench {
  color: #263238;
}

.care-review-head,
.care-filter-shell,
.care-search-summary,
.care-progress,
.care-list-card,
.care-row-card,
.care-empty-state {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.care-review-head,
.care-filter-shell,
.care-search-summary,
.care-list-card,
.care-row-card,
.care-table-head {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  box-sizing: border-box;
  box-shadow: none;
  width: 100%;
}

.care-review-head {
  align-items: flex-end;
  background: #ffffff;
  border-color: #c4d3d9;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  box-shadow: 0 12px 20px -18px rgba(38, 50, 56, 0.55);
  display: flex;
  gap: 22px;
  justify-content: space-between;
  overflow: visible;
  padding: 24px 26px;
  position: relative;
  z-index: 2;
}

.care-review-head::before {
  border: 1px solid #c4d3d9;
  border-bottom: 0;
  border-radius: 7px 7px 0 0;
  content: "";
  height: 14px;
  left: -1px;
  pointer-events: none;
  position: absolute;
  right: -1px;
  top: -1px;
  z-index: 1;
}

.care-title-row {
  align-items: flex-end;
  display: flex;
  gap: 18px;
  justify-content: space-between;
  position: relative;
  width: 100%;
  z-index: 2;
}

.care-title-block h5 {
  color: #263238;
  font-weight: 700;
  letter-spacing: 0;
  margin: 4px 0 0;
}

.care-title-block p {
  color: #607d8b;
  line-height: 1.45;
  margin: 6px 0 0;
  max-width: 820px;
}

.care-search-toggle {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cfd8dc;
  border-radius: 999px;
  color: #263238;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.82rem;
  font-weight: 700;
  gap: 8px;
  min-height: 40px;
  justify-content: center;
  padding: 0 13px 0 16px;
}

.care-search-toggle i {
  color: #00897b;
  font-size: 19px;
}

.care-filter-shell {
  border-color: #c4d3d9;
  border-radius: 0;
  border-top: 0;
  box-shadow: 0 14px 24px -24px rgba(38, 50, 56, 0.68);
  overflow: visible;
  padding: 18px 24px 22px;
}

.care-filter-card {
  background: #ffffff;
  border: 1px solid #c7d3d8;
  border-radius: 6px;
  box-shadow: none;
  overflow: visible;
  padding: 10px;
  width: 100%;
}

.care-filter-card :deep(.sectionx > br) {
  display: none;
}

.care-filter-card :deep(form) {
  margin: 0;
}

.care-filter-card :deep(.row) {
  align-items: stretch;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 10px;
  margin-bottom: 10px;
}

.care-filter-card :deep(.col) {
  border: 1px solid #c7d3d8;
  border-radius: 6px;
  min-width: 0;
  padding: 0 !important;
  width: 100% !important;
}

.care-filter-card :deep(nav) {
  background: transparent !important;
  box-shadow: none !important;
  height: auto;
  line-height: normal;
  min-height: 52px;
}

.care-filter-card :deep(.input-field),
.care-filter-card :deep(.nav-wrapper) {
  background: transparent;
  height: auto;
  line-height: normal;
  margin: 0;
  min-height: 52px;
}

.care-filter-card :deep(input),
.care-filter-card :deep(.select-wrapper input.select-dropdown) {
  background: transparent;
  border: none !important;
  box-sizing: border-box;
  color: #263238 !important;
  font-size: 1.02rem;
  font-weight: 700;
  height: 52px !important;
  line-height: 52px;
  margin: 0;
  padding: 0 42px 0 16px !important;
  width: 100%;
}

.care-filter-card :deep(input:focus) {
  box-shadow: inset 0 -2px 0 #00897b !important;
}

.care-filter-card :deep(.material-icons) {
  color: #00897b !important;
  height: 52px;
  line-height: 52px;
  right: 10px;
  top: 0;
}

.care-filter-card :deep(.dropdown-content) {
  border-top: 1px solid #dfe7ea;
  box-shadow: none;
  margin: 0;
  max-height: 190px;
  overflow-y: auto;
  position: static !important;
  transform: none !important;
  width: 100% !important;
  z-index: 1;
}

.care-filter-card :deep(.dropdown-content li > span) {
  color: #00897b;
  line-height: 1.35;
  padding: 12px 20px;
}

.care-search-summary {
  align-items: center;
  background: #f7f7f7;
  border-color: #c4d3d9;
  border-top: 0;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  box-shadow: 0 12px 22px -24px rgba(38, 50, 56, 0.68);
  display: flex;
  gap: 14px;
  justify-content: space-between;
  padding: 14px 24px;
}

.summary-label {
  color: #607d8b;
  flex: 0 0 auto;
  font-size: 0.74rem;
  font-weight: 700;
  text-transform: uppercase;
}

.summary-content {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-end;
  min-width: 0;
  text-align: right;
}

.care-search-summary :deep(.chip),
.summary-chip {
  background: #ffffff !important;
  border: 1px solid #80cbc4;
  border-radius: 999px;
  color: #263238 !important;
  display: inline-flex;
  font-size: 0.82rem;
  font-weight: 700;
  height: auto;
  line-height: 1.2;
  margin: 0 6px 6px 0;
  padding: 7px 12px;
}

.care-progress {
  background: #e7ecef;
  border: 1px solid #c4d3d9;
  border-top: 0;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 14px 24px -24px rgba(38, 50, 56, 0.68);
  height: 4px;
  overflow: hidden;
}

.care-list-card {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: 0 18px 34px -31px rgba(38, 50, 56, 0.75);
  display: grid;
  gap: 0;
  margin-top: 18px;
  overflow: hidden;
  padding: 0;
}

.care-table-head {
  background: #f5f7f8;
  border: 0;
  border-bottom: 1px solid #e3e8eb;
  border-radius: 0;
  color: #607d8b;
  display: grid;
  font-size: 0.69rem;
  font-weight: 700;
  gap: 18px;
  grid-template-columns: 52px minmax(270px, 1.7fr) minmax(170px, 0.95fr) minmax(210px, 1.2fr) minmax(110px, 0.65fr);
  margin: 0;
  padding: 12px 22px;
  text-transform: uppercase;
}

.care-row-card {
  background: #ffffff;
  border: 0;
  border-bottom: 1px solid #d8e1e5;
  border-radius: 0;
  box-shadow: none;
  margin: 0;
  padding: 22px;
  transition: background-color 0.18s ease, box-shadow 0.18s ease;
}

.care-row-card:nth-child(even) {
  background: #fbfcfd;
}

.care-list-card > .care-row-card:last-child {
  border-bottom: 0;
}

.care-row-card:hover {
  background: #f4f8f8;
}

.care-row-grid {
  align-items: center;
  display: grid;
  gap: 18px;
  grid-template-columns: 52px minmax(270px, 1.7fr) minmax(170px, 0.95fr) minmax(210px, 1.2fr) minmax(110px, 0.65fr);
}

.care-number {
  align-items: center;
  background: #f8fafb;
  border: 1px solid #dce6ea;
  border-radius: 6px;
  color: #607d8b;
  display: inline-flex;
  font-size: 0.82rem;
  font-weight: 700;
  height: 30px;
  justify-content: center;
  margin: 0;
  width: 36px;
}

.care-person h6 {
  align-items: center;
  color: #263238;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.01rem;
  font-weight: 700;
  gap: 8px;
  line-height: 1.35;
  margin: 0;
}

.care-contact-line {
  align-items: center;
  color: #78909c;
  display: flex;
  flex-wrap: wrap;
  font-size: 0.84rem;
  font-weight: 500;
  gap: 8px;
  line-height: 1.35;
  margin-top: 7px;
}

.contact-dot {
  background: #cfd8dc;
  border-radius: 50%;
  display: inline-block;
  height: 5px;
  width: 5px;
}

.care-id-line {
  align-items: center;
  color: #78909c;
  display: flex;
  flex-wrap: wrap;
  font-size: 0.8rem;
  font-weight: 600;
  gap: 7px;
  line-height: 1.35;
  margin-top: 7px;
}

.care-id-line span {
  color: #90a4ae;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
}

.care-id-line strong {
  color: #455a64;
  font-weight: 700;
}

.care-type-text {
  border-radius: 999px;
  font-size: 0.74rem;
  font-weight: 600;
  line-height: 1.1;
  padding: 4px 7px;
}

.care-type-text.is-principal {
  background: #d8ffd6;
  border: 1px solid #46d85a;
  color: #08731b;
}

.care-type-text.is-spouse {
  background: #dbeafe;
  border: 1px solid #4f8cff;
  color: #104bb5;
}

.care-type-text.is-dependant {
  background: #fff1b8;
  border: 1px solid #ffbf1a;
  color: #805400;
}

.care-type-text.is-unclassified {
  background: #eef2f4;
  border: 1px solid #b8c4ca;
  color: #455a64;
}

.care-data-cell {
  border-left: 1px solid #dfe7ea;
  min-width: 0;
  padding-left: 18px;
}

.care-data-cell > span:first-child {
  color: #78909c;
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1;
  margin-bottom: 7px;
  text-transform: uppercase;
}

.care-cell-value,
.care-period {
  color: #263238;
  font-size: 0.94rem;
  font-weight: 400;
  line-height: 1.35;
  margin: 0;
}

.care-period {
  color: #455a64;
}

.care-empty-state {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  color: #607d8b;
  margin-top: 18px;
  padding: 34px 22px;
  text-align: center;
}

.care-empty-state img {
  background: #f8fafb;
  border: 1px solid #e3e8eb;
  padding: 14px;
  width: 108px;
}

.care-empty-state p {
  margin: 8px 0 0;
}

@media only screen and (max-width: 992px) {
  .care-review-head,
  .care-title-row {
    align-items: flex-start;
    flex-direction: column;
  }

  .care-row-grid {
    gap: 16px;
    grid-template-columns: minmax(0, 1.55fr) minmax(170px, 0.95fr) minmax(180px, 1fr);
  }

  .care-data-cell {
    padding-left: 14px;
  }
}

@media only screen and (max-width: 600px) {
  .care-review-head {
    padding: 22px;
  }

  .care-title-block h5 {
    font-size: 1.45rem;
  }

  .care-title-block p {
    font-size: 0.94rem;
  }

  .care-search-toggle {
    justify-content: space-between;
    width: 100%;
  }

  .care-filter-card {
    padding: 10px;
  }

  .care-search-summary {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
    padding: 12px 16px;
  }

  .summary-content {
    justify-content: flex-start;
    text-align: left;
  }

  .care-list-card {
    background: transparent;
    border: 0;
    box-shadow: none;
    gap: 11px;
    overflow: visible;
  }

  .care-row-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .care-row-card {
    border: 1px solid #d8e1e5;
    border-radius: 8px;
    padding: 16px;
  }

  .care-list-card > .care-row-card:last-child {
    border-bottom: 1px solid #d8e1e5;
  }

  .care-person h6 {
    font-size: 0.98rem;
  }

  .care-data-cell {
    border-left: 0;
    border-top: 1px solid #edf2f4;
    padding-left: 0;
    padding-top: 12px;
  }

  .care-cell-value,
  .care-period {
    font-size: 0.9rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .care-review-head,
  .care-filter-shell,
  .care-search-summary,
  .care-progress,
  .care-list-card,
  .care-row-card,
  .care-empty-state {
    animation: none;
  }
}
</style>
